import { Box, ListItemIcon, MenuItem, Select, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import TaskTypeIcon from './TaskTypeIcon';
import { taskTypes } from '@/utils/constants';

const TaskTypeSelect = ({ disabled }) => {
	const formik = useFormikContext();
	const { values, setFieldValue } = formik;

	return (
		<Select
			name='taskType'
			value={values.taskType}
			disabled={disabled}
			onChange={(e) => {
				const selectedValue = e.target.value;
				setFieldValue('taskType', selectedValue);
				if (selectedValue === 'MEETING' && !values.isExistingTask) {
					setFieldValue('createCalendarEvent', true);
				}
				if (selectedValue !== 'MEETING') {
					setFieldValue('attendees', []);
					if (!values.isExistingTask) {
						setFieldValue('createCalendarEvent', false);
					}
				}
			}}
			fullWidth={true}
			renderValue={(value) => (
				<Box display='flex' alignItems='center'>
					<TaskTypeIcon {...{ value }} />

					<Typography sx={{ paddingLeft: '0.5em' }} variant='body1' noWrap>
						{value}
					</Typography>
				</Box>
			)}
		>
			{taskTypes.map((value) => {
				return (
					<MenuItem value={value} key={`task-type-selection-${value}`}>
						<ListItemIcon>
							<TaskTypeIcon {...{ value }} />
						</ListItemIcon>

						<Typography variant='body1' noWrap>
							{value}
						</Typography>
					</MenuItem>
				);
			})}
		</Select>
	);
};

export default TaskTypeSelect;
